import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const TitleOfCol = ({ colTitle, align = 'center' }) => {
    const { t } = useTranslation();
    const columname = t(colTitle);
    
    return (
        <div 
            className="titleData" 
            style={{
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'center',
                height: '100%',
                width: '100%'
            }}
        >
            <div style={{ 
                fontSize: '12px',
                margin: '0',
                fontWeight: 'semibold',
                lineHeight: '1.2',
                display: 'flex',
                flexDirection: 'column',
                alignItems: align === 'left' ? 'flex-start' : 'center',
                justifyContent: 'center',
                textAlign: align,
                width: '100%'
            }}>
                {columname.split(' ').map((word, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={index} style={{ 
                        margin: '1px 0',
                        textAlign: align === 'left' ? 'left' : 'center',
                        width: '100%'
                    }}>
                        {word}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default TitleOfCol

TitleOfCol.propTypes = {
    colTitle: PropTypes.string.isRequired,
    align: PropTypes.oneOf(['left', 'center', 'right'])
}

TitleOfCol.defaultProps = {
    align: 'center'
}